import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialSearchForm, ISearchForm } from "redux/searchForm";

export const searchQuerySlice = createSlice({
  name: "search form",
  initialState: initialSearchForm,
  reducers: {
    updateSearchQuery: (state, action: PayloadAction<ISearchForm>) => {
      return action.payload;
    },
    changeSearchQuerySearchRequestId: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.searchRequestId = action.payload;
    },
    changeSearchQueryMetaStorageTimeout: (
      state,
      action: PayloadAction<Date>,
    ) => {
      state.metaStorageTimeout = action.payload;
    },
  },
});

export const {
  updateSearchQuery,
  changeSearchQuerySearchRequestId,
  changeSearchQueryMetaStorageTimeout,
} = searchQuerySlice.actions;
